'use client'
import React, { useEffect, useState } from 'react';
import Image from 'next/image';

const CarouselComponent = () => {
    const [currentIndex, setCurrentIndex] = useState(0);

    const images = [
        '/images/vendingimgs/1.png',
        '/images/vendingimgs/2.png',
        '/images/vendingimgs/3.png',
        '/images/vendingimgs/auto1.jpg',
        '/images/vendingimgs/auto2.jpg',
        // '/images/vendingimgs/CHV-30.jpg',
    ];

    useEffect(() => {
        const intervalId = setInterval(() => {
            setCurrentIndex((prevIndex) =>
                prevIndex === images.length - 1 ? 0 : prevIndex + 1
            );
        }, 3000);

        return () => clearInterval(intervalId);
    }, [images.length]);

    const translateValue = -100 * currentIndex;

    return (
        <div className="hero-imgs">
            <div id="vending-carousel">
                <div className="vending-slider" style={{ transform: `translateX(${translateValue}%)` }}>
                    {images.map((image, index) => (
                        <Image key={index} width={512} height={512} src={image} alt={`vending machine ${index + 1}`} />
                    ))}
                </div>
            </div>
            <Image width={512} height={512} id="mc-2" src="/images/vendingimgs/auto2.jpg" alt="vending machine" />
        </div>
    );
};

export default CarouselComponent;
